import AvatarImage1 from "assets/images/avatar/avatar_small_1.png";
import AvatarImage2 from "assets/images/avatar/avatar_small_2.png";
import AvatarImage3 from "assets/images/avatar/avatar_small_3.png";
import AvatarImage4 from "assets/images/avatar/avatar_small_4.png";
import AvatarImage5 from "assets/images/avatar/avatar_small_5.png";
import AvatarImage6 from "assets/images/avatar/avatar_small_6.png";
import AvatarImage7 from "assets/images/avatar/avatar_small_7.png";
import AvatarImage8 from "assets/images/avatar/avatar_small_8.png";
import AvatarImage9 from "assets/images/avatar/avatar_small_9.png";
import AvatarImage10 from "assets/images/avatar/avatar_small_10.png";
import AvatarImage11 from "assets/images/avatar/avatar_small_11.png";
import AvatarImage12 from "assets/images/avatar/avatar_small_12.png";
import AvatarImage13 from "assets/images/avatar/avatar_small_13.png";
import AvatarImage14 from "assets/images/avatar/avatar_small_14.png";
import AvatarImage15 from "assets/images/avatar/avatar_small_15.png";
import WordSearchImage from "assets/images/game-list/lobby_main_wordsearch_left.png";
import SettingImage from "assets/images/settings/icon_settings.png";
import JokerImage from "assets/images/joker_medium.png";
import localizationConstants from "shared/util/translation/constant";
import { IAvatarProps, IOfferConfigProps } from "shared/interface";
import StarterOfferImage from "assets/images/shop/icon_joker_package_starter.png";
import SmallOfferImage from "assets/images/shop/icon_joker_package_1.png";
import BestSellingOfferImage from "assets/images/shop/icon_joker_package_2.png";
import BestSellingOfferImage1 from "assets/images/shop/icon_joker_package_3.png";
import BestSellingOfferImage2 from "assets/images/shop/icon_joker_package_4.png";
import SaveBoxOfferImage from "assets/images/shop/icon_joker_package_5.png";
import SudokuGameImage from "assets/images/game-list/lobby_main_sudoku_right.png";
import GridPuzzleGameImage from "assets/images/game-list/lobby_main_gridpuzzle_right.png";
import CrosswordGameImage from "assets/images/game-list/lobby_main_crossword_right.png";
import WordSearchGameImage from "assets/images/game-list/lobby_main_wordsearch_right.png";
import CrossWordChestImage from "assets/images/spell-chest/icon_crossword.png";
import GridPuzzleChestImage from "assets/images/spell-chest/icon_gridpuzzle.png";
import SudokuChestImage from "assets/images/spell-chest/icon_sudoku.png";
import WordSearchChestImage from "assets/images/spell-chest/icon_wordsearch.png";
import { GameType } from "./enum";
import EmptyStarImage from "assets/images/settings/star_empty.png";
import FillUpStarImage from "assets/images/settings/star_set.png";
import { Languages } from "shared/util/localization";

export const API_CONFIG = {
  baseUrl: `${process.env.REACT_APP_BASE_URL}`,
  path: {
    consumableJoker: "inventory",
    settings: "settings",
    user: "user",
    game: "game",
    gameProgress: "game/progress",
    saveGameList: "game/gameList",
    payment: "purchase",
    firebase: "whitelabel/firebase-config",
    feedback: "feedback",
  },
};

export const WINDOW_WIDTH = window.innerWidth;
export const WINDOW_HEIGHT = window.innerHeight;

export const redirectionAppUrl = process.env.REACT_APP_REDIRECT_RATE_FUCHS_URL;
export const X_API_KEY = process.env.REACT_APP_X_API_KEY || "xtest789@";
export const logTypeKey = process.env.REACT_APP_LOG_TYPE_KEY;
export const defaultSiteName =
  process.env.REACT_APP_SITE_NAME || "sta_ratefuchs";

export const SUPPORTEDLANGUAGES = [Languages.DE, Languages.EN];

export const INPUT_MAX_LENGTH = {
  text: 255,
  textarea: 1000,
  default: 524288,
};

export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[\W_])(?!.*\s).{8,}$/;

export const AvatarImageArray: IAvatarProps[] = [
  {
    avatarId: 1,
    avatarImage: AvatarImage1,
  },
  {
    avatarId: 2,
    avatarImage: AvatarImage2,
  },
  {
    avatarId: 3,
    avatarImage: AvatarImage3,
  },
  {
    avatarId: 4,
    avatarImage: AvatarImage4,
  },
  {
    avatarId: 5,
    avatarImage: AvatarImage5,
  },
  {
    avatarId: 6,
    avatarImage: AvatarImage6,
  },
  {
    avatarId: 7,
    avatarImage: AvatarImage7,
  },
  {
    avatarId: 8,
    avatarImage: AvatarImage8,
  },
  {
    avatarId: 9,
    avatarImage: AvatarImage9,
  },
  {
    avatarId: 10,
    avatarImage: AvatarImage10,
  },
  {
    avatarId: 11,
    avatarImage: AvatarImage11,
  },
  {
    avatarId: 12,
    avatarImage: AvatarImage12,
  },
  {
    avatarId: 13,
    avatarImage: AvatarImage13,
  },
  {
    avatarId: 14,
    avatarImage: AvatarImage14,
  },
  {
    avatarId: 15,
    avatarImage: AvatarImage15,
  },
];

export const CrosswordHelpArray = [
  {
    helpImage: AvatarImage1,
    helpDescription:
      "Tap the keyboard icon to toggle the keyboard. You can use it to fill the grid with letters or delete them again.",
  },
  {
    helpImage: AvatarImage1,
    helpDescription:
      "The marker highlights the current field. Your next input will appear there. Tap on any field to move the marker.",
  },
  {
    helpImage: SettingImage,
    helpDescription:
      "You can use hints at any time to fill in the correct number in the currently selected field.",
  },
];

export const GameLobbyHelpArray = [
  {
    helpImage: WordSearchImage,
    helpDescription:
      localizationConstants.swipeLeftOrRightToSelectCrosswordOrSudokuPuzzle,
  },
  {
    helpImage: JokerImage,
    helpDescription: localizationConstants.hintButtonDescription,
  },
  {
    helpImage: SettingImage,
    helpDescription: localizationConstants.helpSettingDescription,
  },
];

export const GameNameNavbarArray = [
  {
    link: "crossword",
    title: localizationConstants.crossword,
    id: "0",
  },
  {
    link: "gridPuzzle",
    title: localizationConstants.gridPuzzle,
    id: "1",
  },
  {
    link: "sudoku",
    title: localizationConstants.sudoku,
    id: "2",
  },
  {
    link: "wordSearch",
    title: localizationConstants.wordSearch,
    id: "3",
  },
];

export const WordSearchGameArray = [
  {
    link: "#crosswordClue",
    imageSrc: CrossWordChestImage,
  },
  {
    link: "#gridPuzzleClue",
    imageSrc: GridPuzzleChestImage,
  },
  {
    link: "#wordSearchClue",
    imageSrc: WordSearchChestImage,
  },
  {
    link: "#sudokuClue",
    imageSrc: SudokuChestImage,
  },
];

export const offerConfig: { [key: string]: IOfferConfigProps } = {
  10: {
    title: localizationConstants.starterPackage,
    offerImage: StarterOfferImage,
    titleClassName: "starter-package-description",
    className: "starter-detail",
  },
  20: {
    offerImage: SmallOfferImage,
    className: "common-offer-detail",
  },
  30: {
    title: localizationConstants.bestSellingOffer,
    offerImage: BestSellingOfferImage,
    titleClassName: "best-selling-description",
    className: "selling-detail",
  },
  40: {
    offerImage: BestSellingOfferImage1,
    className: "common-offer-detail",
  },
  50: {
    offerImage: BestSellingOfferImage2,
    className: "common-offer-detail",
  },
  60: {
    title: localizationConstants.saveFoxOffer,
    offerImage: SaveBoxOfferImage,
    titleClassName: "save-box-description",
    className: "save-box-detail",
  },
};

export const GameImages: any = {
  [GameType.Sudoku]: SudokuGameImage,
  [GameType.GridPuzzle]: GridPuzzleGameImage,
  [GameType.Crossword]: CrosswordGameImage,
  [GameType.WordSearch]: WordSearchGameImage,
};
const getWhiteLabelKey = () => {
  const separator = process.env.REACT_APP_WHITE_LABEL_SEPARATOR || ".live";
  const host = window.location.host;

  if (host.includes(separator)) {
    const labelKey = host.split(separator)[0];
    if (labelKey && labelKey != "") {
      return labelKey.replaceAll("-", "_");
    }
  }
  return process.env.REACT_APP_WHITE_LABEL_KEY;
};

export const environmentConfig = {
  environmentKey: process.env.REACT_APP_ENVIRONMENT_KEY || "live",
  whiteLabelKey: getWhiteLabelKey(),
  encryptionKey: process.env.REACT_APP_AUTH_ENCRYPT_KEY,
};

export const emptyStarImageArray = [
  { img: EmptyStarImage },
  { img: EmptyStarImage },
  { img: EmptyStarImage },
];
export const oneStarImageArray = [
  { img: FillUpStarImage },
  { img: EmptyStarImage },
  { img: EmptyStarImage },
];
export const twoStarImageArray = [
  { img: FillUpStarImage },
  { img: FillUpStarImage },
  { img: EmptyStarImage },
];
export const threeStarImageArray = [
  { img: FillUpStarImage },
  { img: FillUpStarImage },
  { img: FillUpStarImage },
];

export const sudokuLevels = [
  {
    title: localizationConstants.intermediatePuzzles,
    difficulty: 1,
    key: "intermediate",
    starImageArray: oneStarImageArray,
  },
  {
    title: localizationConstants.hardPuzzles,
    difficulty: 2,
    key: "hard",
    starImageArray: twoStarImageArray,
  },
  {
    title: localizationConstants.proPuzzles,
    difficulty: 3,
    key: "pro",
    starImageArray: threeStarImageArray,
  },
];

export const gridPuzzleLevels = [
  {
    title: localizationConstants.fullPage,
    difficulty: 1,
    key: "fullPage",
    starImageArray: twoStarImageArray,
  },
  {
    title: localizationConstants.doublePage,
    difficulty: 2,
    key: "doublePage",
    starImageArray: threeStarImageArray,
  },
];

export const crosswordLevels = [
  {
    title: localizationConstants.picturePuzzle,
    difficulty: 1,
    key: "picture",
    contentArea: [1, 2],
    starImageArray: oneStarImageArray,
  },
  {
    title: localizationConstants.fullPage,
    difficulty: 1,
    key: "fullPage",
    contentArea: [0, 1],
    starImageArray: oneStarImageArray,
  },
  {
    title: localizationConstants.doublePage,
    difficulty: 1,
    key: "doublePage",
    contentArea: [2],
    starImageArray: oneStarImageArray,
  },
];

export const purchasePuzzleJoker = 10;

export const modalCloseTimeOut = 100;
